function parseCookieValue(value) {
  if (value === undefined) return undefined
  try {
    const parsed = decodeURIComponent(value)
    if (parsed === 'undefined' || parsed === 'null') return undefined
    return parsed
  } catch (e) {
    if (value === 'undefined' || value === 'null') return undefined
    return value
  }
}

function getCookie(name) {
  const source = document.cookie ? document.cookie.split('; ') : []
  const item = source.find(entry => entry.startsWith(`${name}=`))
  if (!item) return undefined
  return parseCookieValue(item.substring(name.length + 1))
}

export function createCookies() {
  return {
    get(name) {
      if (typeof document === 'undefined') return undefined
      return getCookie(name)
    },
    set(name, value, options = {}) {
      if (typeof document === 'undefined') return
      if (value === undefined || value === null) {
        this.remove(name, options)
        return
      }
      const parts = [`${name}=${encodeURIComponent(value)}`]
      parts.push(`path=${options.path || '/'}`)
      if (options.maxAge) {
        parts.push(`max-age=${options.maxAge}`)
      }
      document.cookie = parts.join('; ')
    },
    remove(name, options = {}) {
      if (typeof document === 'undefined') return
      document.cookie = `${name}=; path=${options.path || '/'}; max-age=0`
    }
  }
}
